import { shallowEqual, useSelector } from 'react-redux'


export const useDealerPhone = () => {
  const { phone } = useSelector((state: any) => state.dealer, shallowEqual)
  return phone as string
}
